import { render } from "./SavedCards.vue?vue&type=template&id=bf08129e"
import script from "./SavedCards.vue?vue&type=script&lang=js"
export * from "./SavedCards.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__